import { Component, OnInit } from '@angular/core';
import { DatePipe } from '@angular/common'
import { Router,ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { Chart } from 'chart.js';
import { Location } from '@angular/common';
import { AppointmentService } from 'src/app/Services/Appointment/appointment.service'
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { User} from 'src/app/Model/User/user.model';
import { UserRole } from 'src/app/Model/Role/user-role.model'
import { BsDatepickerConfig, DatepickerConfig } from 'ngx-bootstrap/datepicker';
import { AuthenticationService } from 'src/app/Services/Authentication/authentication.service';
import { speedDialFabAnimations } from 'src/app/Components/speed-dial-fab.animations';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, Observable, Subscription, throwError, timer } from 'rxjs';
import { map, catchError, switchMap } from 'rxjs/operators';
import { colors } from 'src/utils/colors';
import {  ChangeDetectionStrategy } from '@angular/core';
import { CalendarEvent, CalendarView } from 'angular-calendar';
import * as moment from 'moment';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
import { NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import {NgbDate, NgbCalendar} from '@ng-bootstrap/ng-bootstrap';

import  parse  from 'date-fns/parse'
import {

  CalendarMonthViewBeforeRenderEvent,
  CalendarWeekViewBeforeRenderEvent,
  CalendarDayViewBeforeRenderEvent,

} from 'angular-calendar';

import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format,
} from 'date-fns';
import { DlDateTimeStringModule } from 'angular-bootstrap-datetimepicker';
import { animation } from '@angular/animations';
  import {
    trigger,
    state,
    style,
    animate,
    transition
  } from '@angular/animations';
import { convertCompilerOptionsFromJson } from 'typescript';
import { stringify } from 'querystring';
import { NotificationService } from 'src/app/Services/Notification/notification.service';
import { AppointmentNotificationService } from 'src/app/Services/Appointment/Websocket/appointment-notification.service';

interface Appointment {
  fullName: string;
  timeIn: string;
  timeOut: string;
  pid:string;
  phoneNumber:string;
  branch:string;
  salesRep:string;
  salesRepID:string;
   
 }
@Component({
  selector: 'app-main-dashboard',
  templateUrl: './main-dashboard.component.html',
  styleUrls: ['./main-dashboard.component.css'],
  animations: speedDialFabAnimations
  
}) 
export class MainDashboardComponent implements OnInit {
  private appointmentNotificationSubscription: Subscription | null = null;
   // BehaviorSubject to track appointments
   

  datesSelected:NgbDateStruct[]=[]; 

  hoveredDate: NgbDate | null = null;

  fromDate: NgbDate;
  toDate: NgbDate | null = null;

//timpicker default time
  time = {hour: 12, minute: 0};
  meridian = true;
  
  salesreplist;
  SalesRepAvailabilityModal:NgbModal;
  fabButtons = [
    {//shows all sales rep availability
      icon: 'date_range',
      click:'getFabButtonOption("btn.click")',
      title: "Sales Rep Availability"
    },
    {//searching for clients
      icon: 'contacts',
      title:"Client Search"
    },
    {//assign browsing appointment to free sales rep
      icon: 'autorenew',
      title:'Browsing Assignment'
    },
    /**{
      icon: 'chat',
      click:'getFabButtonOption("btn.click")',
      title: "Chat"
    },,,
    {
      icon: 'lightbulb_outline'
    },
    {
      icon: 'lock'
    }**/
  ];
  mix=[];
  browsingSalesReplist;
  arrangedSalesRep;
  buttons = [];
  fabTogglerState = 'inactive';
tablefreenextarray;
  tablerequestTypearray;
  dayoffForm : FormGroup;
  tagForm : FormGroup;
  blockoffdayForm: FormGroup;
  lunchForm:FormGroup;
  searchForm: FormGroup;
  clientSearchForm: FormGroup;
  assignSalesRepBrowsingForm: FormGroup;
  searchText;
  
 //_url= 'http://multiinspectionreport.com/reception/api';
 //_url= 'https://test.appointele.com/api';
 //_url= 'https://demo.appointele.com/api';
_url= 'https://ciot.appointele.com/api';
//_url= 'https://ciot.appointele.ca/api';
 
  events: any;
  items: Array<CalendarEvent<{ time: any }>> = [];
  viewDate: Date = new Date();
  view: CalendarView = CalendarView.Month;
  events$: Observable<CalendarEvent<{ appointment: Appointment }>[]>;
  activeDayIsOpen: boolean = false;

  allSalesRep;
  aptPhone;
  salesrepfreetime;
  salesrepfreenext:any=[];
  mainSalesReplist;
  salesReplist;
  reparray=[];
  OffMessage;
  repobj=[];
  lunchreparray=[];

  dayoffreparray=[];
clientSearchList:any=[];

finalbrowsingsalesrep;
  finalbrowsingsalesrepindex;
allbrowsingappointmentfortoday;
  inProgressModalList=[];
  allappointment;
  todaypersonCount;
  alltodaysappointment=[];
  allAptsWithColors=[];
  error=[];
  currentUser:User;
  username;
  branch;
role;
success;
color;

loggedInUsername
loggedInUserBranch;
loggedInUserFullname;
loggedInUserId;

newdates=[];

timeslot=[
  '9:30 AM - 10:30 AM',
  '10:30 AM - 11:30 AM',
  '11:30 AM - 12:30 PM',
  '12:30 PM - 1:30 PM',
  '1:30 PM - 2:30 PM',
  '2:30 PM - 3:30 PM',
  '3:30 PM - 4:30 PM',
  '4:30 PM - 5:30 PM',
  
]

validationMessages = {
  'salesRep': {
    'required': 'required',
    
  },
  'dayoffDate': {
    'required': 'required',
  },
  'blockoffDaytimeIn': {
    'required': 'required',
  },
  'blockoffDaytimeOut': {
    'required': 'required',
  },
  'requestType': {
    'required': 'required',
  },

};


formErrors = {
  'salesRep': '',
  'dayoffDate': '',
  'blockoffDaytimeIn':'',
  'blockoffDaytimeOut':'',
  'requestType':'',
 
};

requestTypeList=['Block Off','Meeting','Training']
datePickerConfig: Partial<BsDatepickerConfig>;
  direction: string="ltr";
  constructor(calendar: NgbCalendar,private fb: FormBuilder,
      private router: Router,
      private modalService: NgbModal,
      private _location: Location,
      private actroute: ActivatedRoute,
      private _authenticationService: AuthenticationService,
      private _appointment_notificationService: AppointmentNotificationService,
      private _appointment: AppointmentService,
      private _http: HttpClient,
      public datepipe: DatePipe) {

        var lang=localStorage.getItem('language');
      if(lang=="ar"){
        this.direction="rtl";
        
      }else{
        this.direction="ltr";
      }
        this.fromDate = calendar.getToday();
        this.toDate = calendar.getNext(calendar.getToday(), 'd', 10);


        let now = moment();

        this._authenticationService.currentUser.subscribe(x => this.currentUser = x);
        if(this.currentUser){
          this.username=this.currentUser.firstName+' '+this.currentUser.middleName+' '+this.currentUser.lastName;
          this.branch=this.currentUser.branch;
          this.role=this.currentUser.role;


          this.loggedInUsername=this.currentUser.userName;
          this.loggedInUserFullname= this.username;
          this.loggedInUserBranch= this.branch
          this.loggedInUserId=this.currentUser.userName;
      
          
      
         }

         this.datePickerConfig = Object.assign({}, {
          containerClass: 'theme-dark-blue',
          showWeekNumbers: false,
          
        //  orientation: "top auto",
          minDate: new Date(2020, 0, 1),//Month starts at 0, so January is 0
          maxDate: new Date(2050, 11, 31),
          dateInputFormat: 'DD/MM/YYYY'
        });
      

       }
 
  ngOnInit(): void {


    // this._appointment_notificationService.startListening(
    //   this.loggedInUserId, 
    //   this.role,
    //   this.loggedInUserBranch
    // );
    
    // Subscribe to notifications
    // this.appointmentNotificationSubscription = this._appointment_notificationService.notification$.subscribe(
    //   notification => {
    //     if (notification && typeof notification === 'object' && notification.pid) {
    //       // Check if this appointment already exists in our list
    //       const exists = this.alltodaysappointment.some(n => n.id === notification.pid);
          
    //       if (!exists) {
    //         // Option 1: Refresh the entire list
    //         this.getTodaysAppointment();
            
    //         // Option 2: Or just add the new appointment to the list if it contains all needed data
    //         // if (notification.data) {
    //         //   this.alltodaysappointment = [notification.data, ...this.alltodaysappointment];
    //         // }
    //       }
    //     }
    //   },
    //   error => {
    //     console.error('Error in appointment notification subscription:', error);
    //   }
    // );
  
//console.log(this.branch);
this.getSalesRepList(this.branch);
this.getMainSalesRepList(this.branch);
this.getTodaysAppointment();
this.getTodaysPersonCount(this.branch);
 

    this.fetchEvents();


    
    this.blockoffdayForm = this.fb.group({
      modalMsg: new FormControl(''),
      requestType: new FormControl('', [Validators.required]),
      salesRep: new FormControl('', [Validators.required]),
      fullName: new FormControl(''),
      blockoffDaytimeIn: new FormControl('', [Validators.required]),
      blockoffDaytimeOut: new FormControl('', [Validators.required]),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });
    

    
    this.tagForm = this.fb.group({
      modalMsg: new FormControl(''),
      pid: new FormControl(''),
      fullName: new FormControl(''),
      timeIn: new FormControl(''),
      tag: new FormControl('', [Validators.required]),
      branch: new FormControl(''),
      actionPerformedBy: new FormControl(this.loggedInUserId)
    });

    
    

this.dayoffForm = this.fb.group({
  modalMsg: new FormControl(''),
  salesRep: new FormControl('', [Validators.required]),
  dayOffDates: new FormControl('', [Validators.required]),
  branch: new FormControl(''),
  actionPerformedBy: new FormControl(this.loggedInUserId)
});




this.lunchForm = this.fb.group({
  modalMsg: new FormControl(''),
  salesRep: new FormControl('', [Validators.required]),
  lunchDates: new FormControl('',[Validators.required]),
  lunchTime: new FormControl(''),
  branch: new FormControl(''),
  actionPerformedBy: new FormControl(this.loggedInUserId)
});


this.clientSearchForm = this.fb.group({
  modalMsg: new FormControl(''),
  phone: new FormControl('', [Validators.required]),
  branch: new FormControl(''),
  actionPerformedBy: new FormControl(this.loggedInUserId)
});

this.searchForm = this.fb.group({
  searchPhoneText: new FormControl(''),
});

this.assignSalesRepBrowsingForm = this.fb.group({
  modalMsg: new FormControl(''),
  pid: new FormControl('', [Validators.required]),
  branch: new FormControl('', [Validators.required]),
  salesRep: new FormControl(''),
  requestType:new FormControl(''),
  actionPerformedBy: new FormControl(this.loggedInUserId)
});
/**
this.searchForm.get('searchText').valueChanges
  .subscribe(checkedValue => {
const search = this.searchForm.get('searchText');

console.log(search.value);

this.clientSearch(search.value);
});
**/
this.lunchForm.patchValue({
  lunchTime:this.time,
});

  }//End og ngOnInit



  change(value:NgbDateStruct[])
  {
    this.datesSelected=value;
  
  }
 
/************************************************************* */
//verifies if the rep is available for next 30 min
checkSalesRepAvailabilityForNext30(rep){
  //console.log(rep);

  if (!Array.isArray(this.salesrepfreenext) && this.salesrepfreenext!=null && this.salesrepfreenext!="undefined") {
//this.salesrepfreenext.indexOf(rep)> -1;}
//console.log(this.salesrepfreenext);
var x=Object.keys(this.salesrepfreenext);
x.includes(rep);

//console.log(x.includes(rep));
  }

}

/************************************************************* */
//updates arranged sales rep list for browsing assignment
  updateSalesRepListForBrowsing(){
    //unshift add to the beginning of array
    this.browsingSalesReplist.unshift(this.loggedInUserBranch);
    
    
    this._appointment.updateSalesRepListForBrowsing(this.browsingSalesReplist)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
      this.getArrangedSalesRepForBrowsing();
      this.getSalesRepFreeTime();
      //this.getSalesRepFreeForNext30();
     // document.getElementById("openSuccessModalButton").click();
      this.browsingSalesReplist.shift(this.loggedInUserBranch);
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
      this.browsingSalesReplist.shift(this.loggedInUserBranch);
    }       
    );
  }
/************************************************************* */
assignSalesRepToBrowsing(rep,index){
  //console.log(index);
  this.finalbrowsingsalesrep=rep.fullName;
  this.finalbrowsingsalesrepindex=index;
 // moveItemInArray(this.browsingSalesReplist, 1, 0);
 var qdate=new Date();
 var queryDate=this.datepipe.transform(qdate,'yyyy-MM-dd H:mm:s' );
 //console.log(queryDate);
 this.getAllBrowsingAppointmentForToday(this.branch,queryDate);
}
  drop(event: CdkDragDrop<string[]>) {
   // console.log(event,event.previousIndex, event.currentIndex);
    moveItemInArray(this.browsingSalesReplist, event.previousIndex, event.currentIndex);
    //console.log(this.browsingSalesReplist);
  }

  /*********************************************************** */
  getAllBrowsingAppointmentForToday(branch,queryDate){
    this._appointment.getAllBrowsingAppointmentForToday(branch,queryDate).subscribe(
      (res) => {
        this.allbrowsingappointmentfortoday= res;
     //console.log(this.allbrowsingappointmentfortoday);
     //closing previous modal
     document.getElementById('openBrowsingAssignmentModalButton').click();

     document.getElementById('openBrowsingListModalButton').click();

      },
      (err) => {
        this.error = err;
      }
    );
  }
/************************************************************* */
   showItems() {
    this.fabTogglerState = 'active';
    this.buttons = this.fabButtons;
  }

  hideItems() {
    this.fabTogglerState = 'inactive';
    this.buttons = [];
  }

  onToggleFab() {
    this.buttons.length ? this.hideItems() : this.showItems();
  }

/***************************************************************** */

  getTodaysAppointment(){
   // console.log(this.branch);
  
    this._appointment.getAllTodaysAppointmentWithoutLunch(this.branch).subscribe(
      (res) => {
        this.alltodaysappointment= res[0];
        console.log(this.alltodaysappointment);
        this.processUsersWithRandomColors(this.alltodaysappointment); 
       
      },
      (err) => {
        this.error = err;
      }
    );
  
  }
/********************************************************* */
  clientSearch(phoneNumber){
//console.log(phoneNumber)
     this._appointment.searchClient(phoneNumber).subscribe(
       (res) => {
         this.clientSearchList= res;
    });
  }
/************************************************************* */
  openFABModal(icon){
    //console.log(icon);
    if(icon=="date_range"){
      this.salesRepFreeTimeModal();
    }
    else if(icon=="contacts"){
      document.getElementById('openClientSearchModalButton').click();
    }
    else if(icon=="autorenew"){
      this.getSalesRepFreeForNext30();
      this.getArrangedSalesRepForBrowsing();
     this.getSalesRepFreeTime();
  
  
      // console.log(this.salesrepfreetime);
      document.getElementById('openBrowsingAssignmentModalButton').click();
    }
    else if(icon=="chat"){
      
      //document.getElementById('ChatModal2').click();
      document.getElementById('openChatModalButton').click();
     /** this.modalService.open('openChatModalButton', {
        centered: true,
        backdrop: 'static'
      });**/
  
    }
  }


 /********************************************************* */
 //gets the save instance of sales rep order for browsing assignment
  getArrangedSalesRepForBrowsing(){
   // console.log(this.loggedInUserBranch);
    if (this.loggedInUserBranch != "None" || this.loggedInUserBranch!="") {
    this._appointment.getArrangedSalesRepForBrowsing(this.loggedInUserBranch).subscribe(
      (res) => {
        this.arrangedSalesRep = res;
        console.log(this.arrangedSalesRep);
        
 
      }
      ,
      (err) => {
        this.error = err;
      }
    );
    }
  }
   /********************************************************* */

   resetBrowsingAssignmentSalesRep(){
    this._appointment.resetArrangedSalesRepForBrowsing(this.loggedInUserBranch).subscribe(
      (res) => {
        this.arrangedSalesRep = res;
        //console.log(this.arrangedSalesRep);
        this.getSalesRepFreeForNext30();
        this.getArrangedSalesRepForBrowsing();
        this.getSalesRepFreeTime();
    
 
      }
      ,
      (err) => {
        this.error = err;
      }
    );
    }
   
 /********************************************************* */

salesRepFreeTimeModal(){
  this.getSalesRepFreeTime();
  document.getElementById('openSalesRepAvailabilityModalButton').click();
  
}
 /********************************************************* */
//gets sales rep that have next 30 min off
 getSalesRepFreeForNext30(){
  //console.log(this.branch);
 var qdate=new Date();
 //var qdate=new Date('2023-05-17 12:15:00');
 //date.setDate(qdate.getDate() -2 );
 //qdate.setHours(qdate.getHours() - 12);
 var queryDate=this.datepipe.transform(qdate,'yyyy-MM-dd H:mm:s' );
 //console.log(queryDate);
   this._appointment.getSalesRepFreeForNext30(this.branch,queryDate).subscribe(
     (res) => {
       this.salesrepfreenext= res;
       console.log(this.salesrepfreenext);

       this.salesrepfreenext=Object.keys(this.salesrepfreenext);
        this.tablefreenextarray=Object.entries(this.salesrepfreenext).map(([key,value])=>{
    const y={[" "]:key}
    return Object.assign({},y,value)
  })


  //console.log(this.tablefreenextarray);

     },
     (err) => {
       this.error = err;
     }
   );
 
 }


  /********************************************************* */

  getSalesRepFreeTime(){
    //console.log(this.branch);
   var qdate=new Date();
   //var qdate=new Date("2023-05-17 12:15:00");
   //date.setDate(qdate.getDate() -2 );
   //qdate.setHours(qdate.getHours() - 12);
   var queryDate=this.datepipe.transform(qdate,'yyyy-MM-dd H:mm:s' );
   //console.log(queryDate);
     this._appointment.getSalesRepFreeTime(this.branch,queryDate).subscribe(
       (res) => {
         this.salesrepfreetime= res;
         console.log(this.salesrepfreetime);

          this.tablerequestTypearray=Object.entries(this.salesrepfreetime).map(([key,value])=>{
      const y={[" "]:key}
    //  console.log(y);
//      console.log(Object.assign({},y,value));


      return Object.assign({},y,value)
    })
    //console.log(this.tablerequestTypearray);
if(this.arrangedSalesRep==null || this.arrangedSalesRep.length == 0){
  this.repobj=[];
  for(var i = 0; i < Object.keys(this.salesrepfreetime).length; i++) {
    var obj={};
   // console.log(Object.keys(this.salesrepfreetime)  [i]);
    obj['fullName']=Object.keys(this.salesrepfreetime)[i];
    obj['count']=0;
    
    
    this.repobj.push(obj);
  };
  //this.browsingSalesReplist=Object.keys(this.salesrepfreetime);
  //console.log(this.repobj);
  this.browsingSalesReplist=this.repobj;
    //console.log(Object.keys(this.salesrepfreetime));
}else{
  this.browsingSalesReplist=this.arrangedSalesRep;
}
    //console.log( this.browsingSalesReplist);//this.salesreplist);
  /** tablerequestTypearray
0:
0: "03:30 pm"
" ": "Olivia Dobrovich"
1: "04:00 pm"
2: "04:30 pm"
3: "05:00 pm"
4: "05:30 pm"*/
    //console.log(this.tablerequestTypearray);
  
 //   const headers=Object.keys(this.tablerequestTypearray[0])
  // console.log(headers)
    var stringversion=JSON.stringify(this.tablerequestTypearray,null,4);
         
       },
       (err) => {
         this.error = err;
       }
     );
   
   }

 /********************************************************* */
 getAllSalesRep(branch){
  // console.log(branch);
   if (branch != "None" || branch!="") {
     this._appointment.getSalesRepByBranch(branch).subscribe(
       (res) => {
         this.allSalesRep = res;
      //   console.log(this.allSalesRep);
         
  
       }
       ,
       (err) => {
         this.error = err;
       }
     );
   }
}
/************************************************************* */
createAptFromFreeTime(salesRep,datetime){
 // console.log(salesRep);
  const now = Date.now();
  const myFormattedDate = this.datepipe.transform(now, 'longDate');
 // console.log(myFormattedDate);
  var ded=new Date(datetime);
  //var ddd=this.datepipe.transform(ded,'H:mm:ss');
   //var time=new Date(myFormattedDate.setTime(21136)); 
    var  finaltime=this.datepipe.transform(myFormattedDate+" "+datetime, 'yyyy-MM-dd H:mm:ss');
  //var finaldate=Date()
  //console.log(finaltime);
  
  this.router.navigate(['../create-appointment',{extra:salesRep,extra1:finaltime,extra2:this.branch}],{relativeTo:this.actroute});
  this.modalService.dismissAll();
}
 /********************************************************* */

 openClientDetails(client){

  this.router.navigate(['../client-details', { extra:client.pid, extra1: client.fullName,extra2:client.phoneNumber,extra3:client.email}], { relativeTo: this.actroute });
 }
 /************************************************************************** */
 openAppointment(list){
  //console.log(list.pid);
  ;
  if(list.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:list.appointmentID,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../appointment-details', { extra: list.pid, extra1: list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn }], { relativeTo: this.actroute });
  }
}

/********************************************************* */

  deleteAppointment(list){
    list['actionPerformedBy']=this.loggedInUsername;
    list['role']=this.role;
    this._appointment.deleteAppointmentbypid(list)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
          
      document.getElementById("openSuccessDeleteModalButton").click();
      
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );
  }
/********************************************************* */
inprogressAppointment(list){
  //var count=((document.getElementById("personcount") as HTMLInputElement).value);
 // console.log(count);
 this.inProgressModalList=list;
  this.inProgressModalList['status']="In Progress";
  this.inProgressModalList['personCount']="0";
  this.modalService.dismissAll();
  this._appointment.setAppointmentStatusbypid(this.inProgressModalList)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccessStatusUpdateModalButton").click();
     
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
 }

/********************************************************* */
 cancelAppointment(list){
  // console.log(list);
  list['status']="Cancelled";
   this._appointment.setAppointmentStatusbypid(list)
   .subscribe(//subscribe to Observable
     response => {console.log('Success!', response);
     this.success=response['SUCCESS'];
         
     document.getElementById("openSuccessStatusUpdateModalButton").click();
     
   },
     error => {console.error('Error!', error);
     this.error=error.error.text ;
   }       
   );
 }
/********************************************************* */
  completeAppointment(list){
   // console.log(list);
   list['status']="Completed"
    this._appointment.setAppointmentCompletebypid(list)
    .subscribe(//subscribe to Observable
      response => {console.log('Success!', response);
      this.success=response['SUCCESS'];
          
      document.getElementById("openSuccessStatusUpdateModalButton").click();
      
    },
      error => {console.error('Error!', error);
      this.error=error.error.text ;
    }       
    );
  }
/********************************************************* */

  clearbarScanAppointment(list){
    // console.log(list);
     this._appointment.clearbarScanbypid(list)
     .subscribe(//subscribe to Observable
       response => {console.log('Success!', response);
       this.success=response['SUCCESS'];
           
       document.getElementById("openSuccesssModalButton").click();
       this. getTodaysAppointment();
     },
       error => {console.error('Error!', error);
       this.error=error.error.text ;
     }       
     );
   }
/********************************************************* */
  getTodaysPersonCount(branch){
    this._appointment.getTodayPersonCount(branch)
    .subscribe(//subscribe to Observable
      response =>{
        this.todaypersonCount=response;
      }
    )
    
  }

/********************************************************* */

editAppointment(list){
 //console.log(list);
  if(list.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:list.pid,extra1:list.timeIn,extra2:list.salesRep,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
  }else{
 
 
   this.router.navigate(['../appointment-edit',{extra:list.pid,extra1:list.fullName,extra2:list.phoneNumber,extra3:list.branch,extra4:list.timeIn}],{relativeTo:this.actroute});
  }
}
/********************************************************* */
scrollToTableView(){
  var myElement = document.getElementById('todayTableview');
var topPos = myElement.offsetTop;
window.scrollTo({left: 0, top:  830});
//myElement.scrollIntoView();
 /**  let scrollToTop = window.setInterval(() => {
    let pos = window.pageYOffset;
    if (pos > 0) {
        window.scrollTo({left: 0, top: pos - 2000}); // how far to scroll on each step
        
    } else {
        window.clearInterval(scrollToTop);
    }
}, 16);*/
}
/********************************************************* */

checkbarScan(date){

  var actualdatetime=new Date(date);
  var currentdatetime=new Date();
  var  daterange=new Date(actualdatetime.setMinutes(actualdatetime.getMinutes() + 60));
//console.log(currentdatetime);
if(currentdatetime<=daterange){
  return true;
} else 
{
  return false;
} 
}

/********************************************************* */
saveSalesRepBrowsingAssignment(){

  //console.log(this.assignSalesRepBrowsingForm)
  //var curposition=+this.browsingSalesReplist.length -1;
  //  moveItemInArray(this.browsingSalesReplist, this.finalbrowsingsalesrepindex, curposition);  
  //  this.updateSalesRepListForBrowsing();
  this._appointment.updateBrowsingAppointmentWithSalesRep(this.assignSalesRepBrowsingForm.value)
  .subscribe(//subscribe to Observable
    response => {console.log('Success!', response);
    this.success=response['SUCCESS'];
    this.assignSalesRepBrowsingForm.reset;    
    //moveItemInArray(array,previousposition,currentposition);
    var curposition=+this.browsingSalesReplist.length -1;
    moveItemInArray(this.browsingSalesReplist, this.finalbrowsingsalesrepindex, curposition);  
    this.updateSalesRepListForBrowsing();
    this.modalService.dismissAll();
    this.getTodaysAppointment();
    document.getElementById("openSuccessModalButton").click();
 //this.router.navigate(['../main-dashboard'],{relativeTo:this.actroute});
  },
    error => {console.error('Error!', error);
    this.error=error.error.text ;
  }       
  );

}
/********************************************************* */

openInProgressModal(modal,apt){
  //console.log(apt);
   this.inProgressModalList=apt;
       var finalmessage= "Please enter: "
     
   
     this.modalService.open(modal, {
       centered: true,
       backdrop: 'static'
     });
   
    
     
   }
   /***************************************************** */

openTagModal(modal,apt){
 //console.log(apt);
  this.getSalesRepList(this.branch);
      var finalmessage= "Please enter: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });
  
    this.tagForm.patchValue({
      modalMsg: finalmessage,
      pid: apt.pid,
      fullName:apt.fullName,
      timeIn:apt.timeIn,
      tag: apt.tag,
      branch: this.branch
    
      
     });
    
  }
  /***************************************************** */

openDayOffModal(modal){
 
  this.getSalesRepList(this.branch);
      var finalmessage= "Please select the Sales Representative and the date: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
        //myCustomModalClass is in main style.css else it wont work to increase modal width
        windowClass : "myCustomModalClass",
    });
  
    this.dayoffForm.patchValue({
      modalMsg: finalmessage,
      branch: this.branch
    
      
     });
    
  }
        /***************************************************** */

    openClientSearchModal(modal){
    
      this.getSalesRepList(this.branch);
          var finalmessage= "Please select the Sales Representative and the date: "
        
      
        this.modalService.open(modal, {
          centered: true,
          backdrop: 'static'
        });
      
        this.lunchForm.patchValue({
          modalMsg: finalmessage,
          branch: this.branch
        
          
        });
        
      }
  /***************************************************** */

openLunchModal(modal){
 
  this.getSalesRepList(this.branch);
      var finalmessage= "Please select the Sales Representative and the date: "
    
  
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static',
      //myCustomModalClass is in main style.css else it wont work to increase modal width
      windowClass : "myCustomModalClass",
    });
  
    this.lunchForm.patchValue({
      modalMsg: finalmessage,
      branch: this.branch
    
      
     });
    
  }
  
/******************************************************************************** */

  openBlockOffDayModal(modal){
 
    this.getSalesRepList(this.branch);
        var finalmessage= "Please select the Sales Representative and the date: "
      
  
      this.modalService.open(modal, {
        centered: true,
        backdrop: 'static',
          //myCustomModalClass is in main style.css else it wont work to increase modal width
      windowClass : "myCustomModalClass",
      });
    
      this.blockoffdayForm.patchValue({
        modalMsg: finalmessage,
        
        branch: this.branch
      
        
       });
    
    }
/******************************************************************************** */

openConfirmBrowsingAssignModal(modal,list){
  document.getElementById('openBrowsingListModalButton').click();
  //document.getElementById('openBrowsingListModalCloseButton').click();
 
      var finalmessage= "Are you sure you would like make assign this to: "
    
//console.log(list);
    this.modalService.open(modal, {
      centered: true,
      backdrop: 'static'
    });
  
    this.assignSalesRepBrowsingForm.patchValue({
      modalMsg: finalmessage,
      pid:list.pid,
      branch: this.branch,
    salesRep: this.finalbrowsingsalesrep,
    requestType:"Walk-In",
    
      
     });
  
  }

/****************************************************************************************************** */
    saveIndividualTag(){
      this.logValidationErrors(this.tagForm);
  
      this._appointment.updateUserAppointmentTag(this.tagForm.value)
            .subscribe(//subscribe to Observable
              response => {
                this.modalService.dismissAll();
                //console.log('Success!', response);
                this.success = response['SUCCESS'];
                this.tagForm.reset;
               
                document.getElementById("openSuccesssModalButton").click();
              },
              error => {
                this.modalService.dismissAll();
                //console.error('ERROR!', error);
                this.error = error.error.text;
                document.getElementById("openErrorModalButton").click();
              }
            );
    }

    
  /**************************************************************************************** */    
  saveIndividualBlockoffday(){
    this.logValidationErrors(this.blockoffdayForm);

    this._appointment.salesrepBlockOffDayAssignment(this.blockoffdayForm.value)
          .subscribe(//subscribe to Observable
            response => {
              this.modalService.dismissAll();
              //console.log('Success!', response);
              this.success = response['SUCCESS'];
              this.blockoffdayForm.reset;
              this.clearData();
              document.getElementById("openOffSuccessModalButton").click();
            },
            error => {
              this.modalService.dismissAll();
              //console.error('ERROR!', error);
              this.error = error.error.text;
              document.getElementById("openErrorModalButton").click();
            }
          );
  }

/******************************************************************* */

     
saveBlockoffday(){
  this.logValidationErrors(this.blockoffdayForm);

  this._appointment.multipleSalesrepBlockOffDayAssignment(this.blockoffdayForm.value)
        .subscribe(//subscribe to Observable
          response => {
            this.OffMessage=[];
            this.modalService.dismissAll();
            //console.log('Success!', response);
            this.OffMessage = response;
            //console.log(this.OffMessage);

            this.blockoffdayForm.reset;
        //   console.log(document.getElementById("openBlockOffSuccessModalButton"));
            document.getElementById("openBlockOffSuccessModalButton").click();
          },
          error => {
            this.modalService.dismissAll();
            //console.error('ERROR!', error);
            this.error = error.error.text;
            document.getElementById("openErrorModalButton").click();
          }
        );
}


/******************************************************************* */



isChecked(value) {
  // console.log(this.productThicknesses);
  //console.log(value);
  // if(controlName=='thicknesses'){
     //console.log(value,this.thicknessesarray.includes(value))
     for (let i = 0; i < this.reparray.length; i++) {
    // this.schedulearray.forEach(element => {
       //console.log(element['userID']);

      // console.log(i,this.schedulearray[i])
       if(this.reparray[i].userID==value){
        //  console.log(this.schedulearray[i]['userID'],value);
        return true;
       }
         //return false;
       
       
     }
     
 //  console.log( this.schedulearray.includes(value));
 
     }

/************************************************************************* */    

/************************************************************************************** */
selectSalesRep(event,controlname,value){
  if(controlname=='blockOff'){

    // for (let i = 0; i < this.schedulearray.length; i++) {
//console.log(value);
      //for (let i = 0; i < this.schedulearray.length; i++) {
        //if(this.schedulearray[i].userID==value.userID){
          console.log(this.reparray.includes(value));
    //if(this.schedulearray.includes(value)){
      if(this.reparray.some(array=> array.userID===value.userID)){
     // const i=this.schedulearray.indexOf(value)
     const i=this.reparray.findIndex(array=> array.userID===value.userID);
      this.reparray.splice(i,1);
    
    }

    else{
      this.reparray.push(value);
 //     if(this.removalschedulearray.includes(value)){
     
    }
 
    
    //console.log(this.reparray);
    this.blockoffdayForm .patchValue({
    salesRep:this.reparray
     });

    } else

    if(controlname=='DayOff'){

    
   
//console.log(value);
   //console.log(this.dayoffreparray.includes(value));

if(this.dayoffreparray.some(array=> array.userID===value.userID)){
const i=this.dayoffreparray.findIndex(array=> array.userID===value.userID);
this.dayoffreparray.splice(i,1);

}

else{
this.dayoffreparray.push(value);
}


//console.log(this.dayoffreparray);
this.dayoffForm .patchValue({
salesRep:this.dayoffreparray
 });
    }

    else
    
    if(controlname=='Lunch'){

    
    // for (let i = 0; i < this.schedulearray.length; i++) {
//console.log(value);
//for (let i = 0; i < this.schedulearray.length; i++) {
  //if(this.schedulearray[i].userID==value.userID){
   // console.log(this.lunchreparray.includes(value));
//if(this.schedulearray.includes(value)){
if(this.lunchreparray.some(array=> array.userID===value.userID)){
// const i=this.schedulearray.indexOf(value)
const i=this.lunchreparray.findIndex(array=> array.userID===value.userID);
this.lunchreparray.splice(i,1);

}

else{
this.lunchreparray.push(value);
//     if(this.removalschedulearray.includes(value)){

}


//console.log(this.lunchreparray);
this.lunchForm .patchValue({
salesRep:this.lunchreparray
 });
    }
   


}
/********************************************************************************************************* */ 

  saveIndividualDayoff(){
    this.logValidationErrors(this.dayoffForm);

    this._appointment.salesrepDayOffAssignment(this.dayoffForm.value)
          .subscribe(//subscribe to Observable
            response => {
              this.modalService.dismissAll();
          //    console.log('Success!', response);
              this.success = response['SUCCESS'];
              this.dayoffForm.reset;
              this.clearData();
              document.getElementById("openSuccesssModalButton").click();
            },
            error => {
              this.modalService.dismissAll();
             // console.error('ERROR!', error);
              this.error = error.error.text;
              document.getElementById("openErrorModalButton").click();
            }
          );
  }
  
  /**************************************************************************************************** */
  
  saveDayoff(){

    this.datesSelected.forEach(value=> {
      //console.log(value);
      const nv = value.year + '-' + value.month + '-' + value.day;
      //console.log(nv);
      if(!this.newdates.includes(nv)){
     this.newdates.push(nv);
      }
      this.dayoffForm.patchValue({
        dayOffDates:this.newdates,
      });
    });

    this.logValidationErrors(this.dayoffForm);

    //this._appointment.multipleSalesrepDayOffAssignment(this.dayoffForm.value)
    this._appointment.multipleSalesrepWithMultipleDayOffAssignment(this.dayoffForm.value)
          .subscribe(//subscribe to Observable
            response => {
              this.OffMessage=[];
              this.modalService.dismissAll();
             // console.log('Success!', response);
              this.OffMessage = response;
              this.dayoffForm.reset;
              this.clearData();
              document.getElementById("openOffSuccessModalButton").click();
            },
            error => {
              this.modalService.dismissAll();
              //console.error('ERROR!', error);
              this.error = error.error.text;
              document.getElementById("openErrorModalButton").click();
            }
          );
  }
  
  /**************************************************************************************************** */

  saveLunch(){
    this.datesSelected.forEach(value=> {
      //console.log(value);
      const nv = value.year + '-' + value.month + '-' + value.day;
      //console.log(nv);
      if(!this.newdates.includes(nv)){
     this.newdates.push(nv);
      }
      this.lunchForm.patchValue({
        lunchDates:this.newdates,
      });
    });

    //console.log(this.lunchForm);
    this.logValidationErrors(this.lunchForm);

    //this._appointment.multipleSalesrepLunchAssignment(this.lunchForm.value)
    this._appointment.multipleSalesrepWithMultipleDatesLunchAssignment(this.lunchForm.value)
          .subscribe(//subscribe to Observable
            response => {
              this.OffMessage=[];
              this.modalService.dismissAll();
             // console.log('Success!', response);
              this.OffMessage = response;
              this.lunchForm.reset;
              this.clearData();
              this.getTodaysAppointment();
              document.getElementById("openOffSuccessModalButton").click();
            },
            error => {
              this.modalService.dismissAll();
              //console.error('ERROR!', error);
              this.error = error.error.text;
              document.getElementById("openErrorModalButton").click();
            }
          );
  }
  
  /**************************************************************************************************** */
  getSalesRepList(branch){
    //  console.log(branch);
      if (branch != "None" || branch!="") {
        this._appointment.getSalesRepByBranch(branch).subscribe(
          (res) => {
            this.salesReplist = res;
         console.log(this.salesReplist);
            
         
          }
          ,
          (err) => {
            this.error = err;
          }
        );
      }
   
      }

/**************************************************************************************************** */
getMainSalesRepList(branch){
  //  console.log(branch);
    if (branch != "None" || branch!="") {
      this._appointment.getMainSalesRepByBranch(branch).subscribe(
        (res) => {
          this.mainSalesReplist = res;
     //  console.log(this.mainSalesReplist);
          
       
        }
        ,
        (err) => {
          this.error = err;
        }
      );
    }
 
    }

 /**************************************************************************************************** */



      backClicked() {
        this._location.back();
      }
    
    
  /************************************************************************************************************************** */
  //Calendar
  /**************************************************************************************************************************** */
  fetchEvents(): void {

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay,
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay,
    }[this.view];

  this.events$ = this._http.get(`${this._url}/active_all_appointment_for_branch_get.php?branch=${this.branch}`)
  .pipe(
    map(({ results }: { results: Appointment[] }) => {
      console.log(results);
     //this.allappointment=results;
      //console.log(this.allappointment);
      if(results!=null ){
      return results.map((appointment: Appointment) => {
        this.colorForRep(appointment.salesRep);
     
     
        /** 
       
        if(appointment.timeOut!="" && appointment.timeOut!=null){
          var timeOut=this.datepipe.transform(new Date(appointment.timeOut), 'yyyy-MM-dd h:mm a');
        
        } else {
          if(appointment.timeIn!=null && appointment.timeIn!=""){
          var timeOute=new Date(appointment.timeIn);
          var time=new Date(timeOute.setMinutes(timeOute.getMinutes() + 30));
          timeOut=this.datepipe.transform(time, 'yyyy-MM-dd h:mm a',"z-0600");
        //  console.log(res[i].timeIn);
          }
        }**/
       // console.log(new Date(appointment.timeIn));

       if(appointment.phoneNumber!=="" && appointment.phoneNumber!=null){
         this.aptPhone=' - '+appointment.phoneNumber;
       }else
       { this.aptPhone="";}
        return {
          title: appointment.fullName+' - '+(new Date(appointment.timeIn).toLocaleTimeString()).replace(/:\d+ /, ' ')+' - '+appointment.salesRep+this.aptPhone,
         
          start: new Date(
            appointment.timeIn
          ),
        
        
          
          color:this.color,
        //  end: new Date(timeOut),
         // cssClass: main-dashboard.component.css,
          meta: {
            appointment,
          },

        };
      });}
    })
  );


}


dayClicked({
  date,
  events,
}: {
  date: Date;
  events: CalendarEvent<{ appointment: Appointment }>[];
}): void {
  if (isSameMonth(date, this.viewDate)) {
    if (
      (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) ||
      events.length === 0
    ) {
      this.activeDayIsOpen = false;
    } else {
      this.activeDayIsOpen = true;
      this.viewDate = date;
    }
  }

}



eventClicked(event: CalendarEvent<{ appointment: Appointment }>): void {
  /**window.open(
    `https://multiinspectionreport.com/reception/appointment-details;extra=${event.meta.appointment.appointmentID};extra1=${event.meta.appointment.fullName};extra2=${event.meta.appointment.phoneNumber}`,
    '_blank'
  );**/

  //console.log(event.meta.appointment);
  if(event.meta.appointment.fullName=='Lunch'){
    this.router.navigate(['../lunch-assignment',{extra:event.meta.appointment.pid,extra1:event.meta.appointment.timeIn,extra2:event.meta.appointment.salesRepID,extra3:event.meta.appointment.branch}],{relativeTo:this.actroute});
  }else{
 
  this.router.navigate(['../appointment-details', { extra:event.meta.appointment.pid, extra1: event.meta.appointment.fullName,extra2:event.meta.appointment.phoneNumber,extra3:event.meta.appointment.branch ,extra4:event.meta.appointment.timeIn}], { relativeTo: this.actroute });
}
}


colorForRep(salesRep){



    
  if(this.salesReplist.some(array=> array.fullName===salesRep)){
    const i= this.salesReplist.findIndex(array=> array.fullName===salesRep);
    //console.log(salesRep);
    
   // console.log(this.salesReplist[i].color)
    if(this.salesReplist[i].color!=null && this.salesReplist[i].color!=""){
      var colour=new String(this.salesReplist[i].color);
      //console.log(this.salesReplist[i].color);
    this.color={primary:this.salesReplist[i].color,secondary:this.salesReplist[i].color};
    } else if(salesRep==''){
      this.color=colors.red;
    } else {
      this.color=colors.black;
    }
    }
/**
  if(salesRep=='Nicolas Salazar'){
    this.color=colors.darkgray;
  }else if(salesRep=='Sonia Garofolo'){
    this.color=colors.yellow;
  } else if(salesRep=='Nancy Ventura'){
    this.color=colors.purple;
  }else if(salesRep=='Olivia Dobrovich'){
    this.color=colors.pink;
  } else if(salesRep=='Jason Branco'){
    this.color=colors.green;
  }else if(salesRep=='Ryan Li'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Caelyn Huang'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Alyssa Vani'){
    this.color=colors.info;
  } else if(salesRep=='Alex Karlee Lafarciola'){
    this.color=colors.brightblue;
  }else if(salesRep=='Magdalena Wojtachnio'){
    this.color=colors.orange;
  } else if(salesRep=='Christelle Aniceto'){
    this.color=colors.lightorange;
  }else if(salesRep=='Zach Cannarozzo'){
    this.color=colors.blue;
  } else if(salesRep=='Alexia Rupolo'){
    this.color=colors.brown;
  }else if(salesRep=='Sandra Arango'){
    this.color=colors.grayblue;
  } else if(salesRep=='Lauren Richardson'){
    this.color=colors.coralred;
  }
  
  //1020 Lawrence
  else if(salesRep=='Zohaib Salman'){
    this.color=colors.blue;
  } else if(salesRep=='Melissa Hu'){
    this.color=colors.purple;
  } else if(salesRep=='Manal Aziz'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Gianna Cammalleri'){
    this.color=colors.orange;
  } else if(salesRep=='Niki Madarasz'){
    this.color=colors.lightorange;
  } else if(salesRep=='Jacquie Kraizer'){
    this.color=colors.pink;
  }
  
  //3050 Vega
  
  else if(salesRep=='Caron Galea'){
    this.color=colors.blue;
  } else if(salesRep=='Erin Ages'){
    this.color=colors.purple;
  } else if(salesRep=='Paola Salafia'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Samantha Garofalo'){
    this.color=colors.orange;
  } else if(salesRep=='Peter Petrauskas'){
    this.color=colors.lightorange;
  } else if(salesRep=='Kristine Golfi'){
    this.color=colors.pink;
  }

  //9151 St Laurent

  else if(salesRep=='Antea Bini'){
    this.color=colors.blue;
  } else if(salesRep=="Antonio D'Auito"){
    this.color=colors.purple;
  } else if(salesRep=='Caterina Panzera'){
    this.color=colors.darkgreen;
  } else if(salesRep=='Christine Naccache'){
    this.color=colors.orange;
  } else if(salesRep=='Fatine Zeroual'){
    this.color=colors.lightgray;
  } else if(salesRep=='Francesco Carbonaro'){
    this.color=colors.pink;
  }  else if(salesRep=='Isabelle Doyon'){
    this.color=colors.blue;
  } else if(salesRep=='Johanne Martineau'){
    this.color=colors.brown;
  }else if(salesRep=="Joseph D'Angelo"){
    this.color=colors.grayblue;
  } else if(salesRep=='Lucia Balan'){
    this.color=colors.coralred;
  }else if(salesRep=='Luigi Biondi'){
    this.color=colors.purpleblue;
  }else if(salesRep=='Maria Forcillo'){
    this.color=colors.info;
  } else if(salesRep=='Michael Tengalia'){
    this.color=colors.brightblue;
  }else if(salesRep=='Mikal Rousseau'){
    this.color=colors.darkgray;
  } else if(salesRep=='Sandra Cruciat'){
    this.color=colors.brown;
  }else if(salesRep=='Sophie Ferrandino'){
    this.color=colors.yellow;
  } else if(salesRep=='Tom Pugliese'){
    this.color=colors.gunmetal;
  }
**/

  else if(salesRep==''){
    this.color=colors.red;
  } else {
    this.color=colors.black;
  }

}





// Add random colors to each user in allUsers
processUsersWithRandomColors(users) {
  this.allAptsWithColors =users.map(user => ({
    ...user,
    
    initialsColor: this.getRandomLightColor()  // Add random color
  }));
  console.log(this.allAptsWithColors);
}

// Function to get initials
getInitials(user: any): string {
  //const firstNameInitial = user.firstName ? user.firstName[0] : '';
  //const lastNameInitial = user.lastName ? user.lastName[0] : '';
  //console.log(user);
  const nameParts = user.trim().split(/\s+/); 

  let firstNameInitial = "";
  let lastNameInitial = "";
  
  if (nameParts.length === 1 && nameParts[0].length === 1) {
      // Single-letter name case (e.g., "J")
      firstNameInitial = nameParts[0].toUpperCase();
      lastNameInitial = "";  // No last name
  } else {
      firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || "";
      lastNameInitial = nameParts.length > 1 ? nameParts[1].charAt(0).toUpperCase() : "";
  }
 // const firstNameInitial = nameParts[0]?.charAt(0).toUpperCase() || "";
  //const lastNameInitial= nameParts[1]?.charAt(0).toUpperCase() || "";
 
  return firstNameInitial + lastNameInitial;

}


// Method to generate a random light color
getRandomLightColor(): string {
    const letters = 'BCDEF'; // Light colors use high values
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * letters.length)];
    }
    return color;
}


/**************************************************************************************************** */
clearData(){
  this.datesSelected = []; 
  this.dayoffreparray=[];
  this.newdates=[];
}
/**************************************************************************************************** */

refresh(): void {
  window.location.reload();
}
/**************************************************************************************************** */
isAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.Administrator;
}

isSystemAdmin() {
  return this.currentUser && this.currentUser.role === UserRole.SystemAdministrator;
}

isReceptionist() {
  return this.currentUser && this.currentUser.role === UserRole.Receptionist;
}

isSalesRep() {
  return this.currentUser && this.currentUser.role === UserRole.SalesRepresentative;
}

isPowerUser() {
  return this.currentUser && this.currentUser.role === UserRole.PowerUser;
}

isSalesSupport() {
  return this.currentUser && this.currentUser.role === UserRole.SalesSupport;
}





onDateSelection(date: NgbDate) {
    if (!this.fromDate && !this.toDate) {
      this.fromDate = date;
    } else if (this.fromDate && !this.toDate && date.after(this.fromDate)) {
      this.toDate = date;
    } else {
      this.toDate = null;
      this.fromDate = date;
    }
  }

  isHovered(date: NgbDate) {
    return this.fromDate && !this.toDate && this.hoveredDate && date.after(this.fromDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.toDate && date.after(this.fromDate) && date.before(this.toDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.fromDate) || (this.toDate && date.equals(this.toDate)) || this.isInside(date) || this.isHovered(date);
  }
  

  checkIn(){
if(this.loggedInUserBranch=='8810JaneSt'){
  this.router.navigate(['../main-signage-dashboard',{}],{relativeTo:this.actroute});
}else{
  this.router.navigate(['../device-appointment-questionaire',{}],{relativeTo:this.actroute});
}
  }





logValidationErrors(group: FormGroup ): void {
  //get the keys from FormGroup object and checks all the keys
  Object.keys(group.controls).forEach((key: string) => {
    const abstractControl = group.get(key);
    //if the key is part of nested FormGroup or any FormGroup then rerun it through the method again to extract formControl
    if (abstractControl instanceof FormGroup) {
      this.logValidationErrors(abstractControl);
    } else {
      //clear any previous error
      this.formErrors[key] = '';
      //check Validation of the formControl
      if (abstractControl && !abstractControl.valid && (abstractControl.touched || abstractControl.dirty)) {
        //if not valid then get the error message of whatever the validation error is from the validationMessage method
        const messages = this.validationMessages[key];
        //for every error in validation get the error key and assign it to the formControl name is formError method
        for (const errorkey in abstractControl.errors) {
          if (errorkey) {
           // console.log(key);
         

            this.formErrors[key] += messages[errorkey] + ''
          }
        }
      }
    }

  });
}

}
